import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { STRINGS } from '@/strings/strings';

interface SubmitButtonProps {
  loading?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  type?: 'button' | 'submit';
}

export function SubmitButton({
  loading = false,
  disabled = false,
  onClick,
  type = 'submit',
}: SubmitButtonProps) {
  return (
    <Button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className="h-12 w-full bg-dream-gold px-8 text-base font-bold text-dream-navy hover:bg-dream-gold/90 disabled:opacity-60"
    >
      {loading ? (
        <>
          <Loader2 aria-hidden className="mr-2 h-4 w-4 animate-spin" />
          {STRINGS.builder.shared.submittingButton}
        </>
      ) : (
        STRINGS.builder.shared.submitButton
      )}
    </Button>
  );
}
